import api from '@/api/api';

export default {

    namespaced: true,

    state: {
        paginasAbonosEnvios: 1,
        remitentesParaAbonos: [],
        deudaUnSoloCliente: 0,
        objetoDatosAbonoSencillo: {},
        objetoDatosMultiple: {},
        objetoDatosCambioDireccion: {},
        resumenCobranza: [],
        totalesCobranza: {},
        nombreAbonante: "",
        objetoDatosImprimirTicketCorteDeCaja: {},
    },
    mutations: {

        getRemitentesParaAbonos(state, datos) {
            state.remitentesParaAbonos = datos;
        },
        getDeudaUnRemitente(state, datos) {
            state.deudaUnSoloCliente = datos;
        },
        insertAbono(state, datos) {
            console.log(datos, 'datos');
            state.objetoDatosAbonoSencillo = datos.envio;
        },
        destroyStoreAbonosEnvios(state) {
            state.objetoDatosAbonoSencillo = {};
            state.objetoDatosMultiple = {};
            state.objetoDatosCambioDireccion = {};
            state.objetoDatosImprimirTicketCorteDeCaja = {};
        },
        insertAbonoMultiple(state, datos) {
            state.objetoDatosMultiple = datos;
        },
        cambioDireccion(state, datos) {
            state.objetoDatosCambioDireccion = datos;
        },
        getResumenCobranza(state, datos) {
            state.resumenCobranza = datos.DATOS;
            state.paginasAbonosEnvios = datos.INFO.paginacion.Paginas;
        },

        destroyResumenDeCobranza(state){
            state.resumenCobranza = []
            state.paginasAbonosEnvios = 1;
            state.totalesCobranza = {};
        },
        getTotalesCobranza(state, datos) {
            state.totalesCobranza = datos;
        },

        registraNombreAbonante(state, datos) {
            state.nombreAbonante = datos;
        },

        
        reimprimirTicketAbono(state, datos) {
            state.objetoDatosAbonoSencillo = datos;
        },

        imprimirTicketCorteDeCaja(state, datos) {
            state.objetoDatosImprimirTicketCorteDeCaja = datos;
        },


    },
    actions: {
        async destroyStoreAbonosEnvios({
            commit,
        },) {
            commit('destroyStoreAbonosEnvios');
        },

        async getTotalesCobranza({
            commit,
        }, objTotalesCobranza) {
            try {
                const res = await api.getTotalesCobranza(objTotalesCobranza);
                // console.log(object);

                if (res.data.INFO.cod === '200') {
                    console.log(res.data.INFO.Totales, 'worales');
                    commit('getTotalesCobranza', res.data.INFO.Totales);
                    return [true];
                } return [false];
            } catch (error) {
                return [false, 'errorcarga'];
            }
        },

        async getDeudaUnRemitente({
            commit,
        }, unRem) {
            try {
                const res = await api.getDeudaUnRemitente(unRem);
                // console.log(object);

                if (res.data.INFO.cod === '200') {

                    commit('getDeudaUnRemitente', res.data.INFO.deuda.Cantidad);
                    return [true];
                } return [false];
            } catch (error) {
                return [false, 'errorcarga'];
            }
        },

        async registraNombreAbonante({
            commit,
        }, nombreAbonante) {
            commit('registraNombreAbonante', nombreAbonante);
        },

        async getRemitentesParaAbonos({
            commit,
        }, abon) {
            try {
                const res = await api.getRemitentesParaAbonos(abon);
                // console.log(object);
                if (res.data.INFO.cod === '200') {
                    commit('getRemitentesParaAbonos', res.data.DATOS);
                    return [true];
                } return [false];
            } catch (error) {
                return [false, 'errorcarga'];
            }
        },

        async getResumenCobranza({
            commit,
        }, resCob) {
            try {
                const res = await api.getResumenCobranza(resCob);
                // console.log(object);
                if (res.data.INFO.cod === '200') {
                    await commit('getResumenCobranza', res.data);
                    return [true];
                } return [false];
            } catch (error) {
                return [false, 'errorcarga'];
            }
        },

        async reimprimirTicketAbono({ commit }, abono) {
            commit('reimprimirTicketAbono', abono);
        },

        async destroyResumenDeCobranza({ commit }) {
            commit('destroyResumenDeCobranza');
        },


        async insertAbono({ commit }, abono) {
            try {
                const res = await api.insertAbono(abono);
                if (res.data.INFO.cod === '200') {
                    commit('enviosInfoEnvio/destroyStoreInfoEnvio', '', { root: true });
                    commit('destroyStoreAbonosEnvios');
                    commit('insertAbono', res.data.INFO);
                    return [true, 'blah'];
                } else if (res.data.INFO.cod === '0600') {
                    return [false, 'envioprevpagado'];
                } return [false, res.data.INFO.msg];
            } catch (error) {
                console.log(error);
            }
        },

        async insertAbonoMultiple({ commit }, abono) {
            try {
                const res = await api.insertAbonoMultiple(abono);
                if (res.data.INFO.cod === '200') {
                    commit('enviosInfoEnvio/destroyStoreInfoEnvio', '', { root: true });
                    commit('destroyStoreAbonosEnvios');
                    commit('insertAbonoMultiple', res.data.INFO.envio);
                    return [true, 'blah'];
                } else if (res.data.INFO.cod === '0600') {
                    console.log('error 0600');
                    return [false, 'envioprevpagado'];
                } return [false, res.data.INFO.msg];
            } catch (error) {
                console.log(error);
            }
        },

        async imprimirTicketCorteDeCaja({ commit }, datosCorteDeCaja) {
            try {
                commit('enviosInfoEnvio/destroyStoreInfoEnvio', '', { root: true });
                commit('destroyStoreAbonosEnvios');
                commit('imprimirTicketCorteDeCaja', datosCorteDeCaja);
                return [true];

            } catch (error) {
                console.log(error);
            }
        },

        async cambioDireccion({ commit }, envDir) {
            try {
                const res = await api.cambioDireccion(envDir);
                if (res.data.INFO.cod === '200') {

                    commit('enviosInfoEnvio/destroyStoreInfoEnvio', '', { root: true });
                    commit('destroyStoreAbonosEnvios');
                    commit('cambioDireccion', res.data.INFO.CambioDireccion);
                    return [true, 'blah'];
                } else return [false, res.data.INFO.msg];
            } catch (error) {
                console.log(error);
            }
        },





    },
};
